import { AppNS } from 'app';
import { DescriptionDataProperty } from 'app/consts/agencyDescriptionData';

import { PayloadAction } from '@reduxjs/toolkit';

import { AuthState } from '../../auth';

export const DESCRIPTION_DATA_REDUCERS = {
  setDescriptionDataStart(state: AuthState, action: PayloadAction<string>) {
    state.isChangingDescriptionData = action.payload;
    state.isChangingDescriptionDataError = false;
  },
  setDescriptionDataFailed(state: AuthState) {
    state.isChangingDescriptionDataError = true;
  },
  setDescriptionDataSuccess(
    state: AuthState,
    action: PayloadAction<{ value: string; property: DescriptionDataProperty }>
  ) {
    state.isChangingDescriptionData = '';
    state.isChangingDescriptionDataError = false;
    if (state.user) {
      if (state.user.company) {
        state.user.company = {
          ...state.user.company,
          [action.payload.property as keyof AppNS.Company]:
            action.payload.value,
        };

        const companyId = state.user.company.id;
        if (companyId) {
          state.user.employments = state.user.employments.map((employment) => {
            if (employment.companyId === companyId) {
              return {
                ...employment,
                company: {
                  ...employment.company,
                  [action.payload.property as keyof AppNS.Company]:
                    action.payload.value,
                },
              };
            }
            return employment;
          });
        }
      } else {
        state.user = {
          ...state.user,
          [action.payload.property as keyof AppNS.User]: action.payload.value,
        };
      }
    }
  },
  setProposalPricingStart(state: AuthState) {
    state.isChangingProposalPricing = true;
    state.isChangingProposalPricingError = false;
  },
  setProposalPricingFailed(state: AuthState) {
    state.isChangingProposalPricingError = true;
  },
  setProposalPricingSuccess(
    state: AuthState,
    action: PayloadAction<{ properties: AppNS.Params }>
  ) {
    state.isChangingProposalPricing = false;
    state.isChangingProposalPricingError = false;
    if (state.user) {
      state.user.company = {
        ...state.user.company,
        proposalBookingsEnabled:
          action.payload.properties.proposalBookingsEnabled,
        pricingPolicy: action.payload.properties.pricingPolicy,
      };

      const companyId = state.user.company.id;
      if (companyId) {
        state.user.employments = state.user.employments.map((employment) => {
          if (employment.companyId === companyId) {
            return {
              ...employment,
              company: {
                ...employment.company,
                proposalBookingsEnabled:
                  action.payload.properties.proposalBookingsEnabled,
                pricingPolicy: action.payload.properties.pricingPolicy,
              },
            };
          }
          return employment;
        });
      }
    }
  },
  setFixedPricingStart(state: AuthState) {
    state.isChangingFixedPricing = true;
    state.isChangingFixedPricingError = false;
  },
  setFixedPricingFailed(state: AuthState) {
    state.isChangingFixedPricingError = true;
  },
  setFixedPricingSuccess(
    state: AuthState,
    action: PayloadAction<{ properties: AppNS.Params }>
  ) {
    state.isChangingFixedPricing = false;
    state.isChangingFixedPricingError = false;
    if (state.user) {
      state.user.company = {
        ...state.user.company,
        fixedPriceBookingsEnabled:
          action.payload.properties.fixedPriceBookingsEnabled,
        termsFixedPrice: action.payload.properties.termsFixedPrice,
        fixedPriceList: action.payload.properties.fixedPriceList,
      };

      const companyId = state.user.company.id;
      if (companyId) {
        state.user.employments = state.user.employments.map((employment) => {
          if (employment.companyId === companyId) {
            return {
              ...employment,
              company: {
                ...employment.company,
                fixedPriceBookingsEnabled:
                  action.payload.properties.fixedPriceBookingsEnabled,
                termsFixedPrice: action.payload.properties.termsFixedPrice,
                fixedPriceList: action.payload.properties.fixedPriceList,
              },
            };
          }
          return employment;
        });
      }
    }
  },
};
